import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SchedulingToolbar = ({
  selectedDate,
  viewMode,
  selectedProductionLine,
  onDateChange,
  onViewModeChange,
  onProductionLineChange,
  onBulkCopy,
  onAutoOptimize,
  onOpenTemplates
}) => {
  const formatDate = (date) => {
    return date?.toLocaleDateString('en-US', { 
      weekday: 'short', 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const navigateDate = (direction) => {
    const newDate = new Date(selectedDate);
    if (viewMode === 'day') {
      newDate?.setDate(newDate?.getDate() + direction);
    } else if (viewMode === 'week') {
      newDate?.setDate(newDate?.getDate() + (direction * 7));
    } else if (viewMode === 'month') {
      newDate?.setMonth(newDate?.getMonth() + direction);
    }
    onDateChange(newDate);
  };

  const productionLines = [
    { value: 'all', label: 'All Lines' },
    { value: 'line-a', label: 'Line A' },
    { value: 'line-b', label: 'Line B' },
    { value: 'line-c', label: 'Line C' },
    { value: 'line-d', label: 'Line D' }
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-4">
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
        <div className="flex flex-wrap items-center gap-3">
          <div className="flex items-center gap-2 bg-muted rounded-lg p-1">
            <button
              className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors duration-250 ${
                viewMode === 'day' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:text-foreground'
              }`}
              onClick={() => onViewModeChange('day')}
            >
              Day
            </button>
            <button
              className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors duration-250 ${
                viewMode === 'week' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:text-foreground'
              }`}
              onClick={() => onViewModeChange('week')}
            >
              Week
            </button>
            <button
              className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors duration-250 ${
                viewMode === 'month' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:text-foreground'
              }`}
              onClick={() => onViewModeChange('month')}
            >
              Month
            </button>
          </div>

          <div className="flex items-center gap-2">
            <button
              className="flex items-center justify-center w-8 h-8 rounded-lg bg-muted hover:bg-muted/80 transition-colors duration-250"
              onClick={() => navigateDate(-1)}
              aria-label="Previous"
            >
              <Icon name="ChevronLeft" size={16} />
            </button>
            <div className="px-4 py-1.5 bg-muted rounded-lg">
              <span className="text-sm font-medium text-foreground">{formatDate(selectedDate)}</span>
            </div>
            <button
              className="flex items-center justify-center w-8 h-8 rounded-lg bg-muted hover:bg-muted/80 transition-colors duration-250"
              onClick={() => navigateDate(1)}
              aria-label="Next"
            >
              <Icon name="ChevronRight" size={16} />
            </button>
            <button
              className="px-3 py-1.5 text-sm font-medium text-primary hover:text-primary/80 transition-colors duration-250"
              onClick={() => onDateChange(new Date())}
            >
              Today
            </button>
          </div>

          <select
            className="px-3 py-1.5 bg-muted rounded-lg text-sm font-medium text-foreground border-none outline-none cursor-pointer"
            value={selectedProductionLine}
            onChange={(e) => onProductionLineChange(e?.target?.value)}
          >
            {productionLines?.map((line) => (
              <option key={line?.value} value={line?.value}>
                {line?.label}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            iconName="Copy"
            onClick={onBulkCopy}
          >
            Copy Shifts
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="Sparkles"
            onClick={onAutoOptimize}
          >
            Auto Optimize
          </Button>
          <Button
            variant="default"
            size="sm"
            iconName="FileText"
            onClick={onOpenTemplates}
          >
            Templates
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SchedulingToolbar;